import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DocumentDuplicateIcon, SparklesIcon } from '@heroicons/react/24/outline'
import { formatDate } from './cycleStatus'

// VH-229 refinement: a week without a plan offers the two ways to get one — the previous week's plan
// again, or a new plan written against the current targets (optionally with wishes).
export function WeekPlanEmptyState({ previousWeek, onCopy, onGenerate, copying = false, generating = false }) {
  const { t, i18n } = useTranslation()
  const [wishes, setWishes] = useState('')
  return (
    <div className="rounded-lg border border-purple-200 bg-purple-50 p-4 space-y-4" data-testid="week-plan-empty">
      <p className="text-sm text-gray-800">{t('weekPlanning.empty.intro')}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-lg border border-gray-200 bg-surface p-3 flex flex-col gap-2">
          <h5 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
            <DocumentDuplicateIcon className="h-5 w-5 text-purple-700" aria-hidden="true" />
            {t('weekPlanning.copy.title')}
          </h5>
          <p className="text-xs text-gray-600 flex-1">
            {previousWeek
              ? t('weekPlanning.copy.body', { date: formatDate(previousWeek, i18n.language) })
              : t('weekPlanning.copy.noPrevious')}
          </p>
          <button type="button" className="btn-primary text-sm" disabled={!previousWeek || copying} onClick={onCopy}
            data-testid="copy-previous-week">
            {copying ? t('weekPlanning.copy.copying') : t('weekPlanning.copy.action')}
          </button>
        </div>
        <div className="rounded-lg border border-gray-200 bg-surface p-3 flex flex-col gap-2">
          <h5 className="text-sm font-semibold text-gray-900 flex items-center gap-2">
            <SparklesIcon className="h-5 w-5 text-purple-700" aria-hidden="true" />
            {t('weekPlanning.generate.title')}
          </h5>
          <p className="text-xs text-gray-600">{t('weekPlanning.generate.body')}</p>
          <label className="text-xs text-gray-700 flex flex-col gap-1">
            {t('weekPlanning.generate.wishes')}
            <textarea className="form-input text-sm" rows={2} maxLength={1000} value={wishes}
              placeholder={t('weekPlanning.generate.wishesPlaceholder')} onChange={(e) => setWishes(e.target.value)} />
          </label>
          <button type="button" className="btn-outline text-sm" disabled={generating} onClick={() => onGenerate(wishes)}
            data-testid="generate-week-plan">
            {generating ? t('weekPlanning.generate.starting') : t('weekPlanning.generate.action')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default WeekPlanEmptyState
